// extracted by mini-css-extract-plugin
module.exports = {"key_value_text":"keyValueText_key_value_text__BWC0h"};